package de.connect2x.timmy.customcomponents

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch

// Diese Methode ist übernommen aus der entsprechenden Datei im Trixnity-Messenger
@Composable
internal fun <T> rememberComputation(vararg keys: Any?, callback: () -> T): T? {
    val state = remember { mutableStateOf<T?>(null) }
    LaunchedEffect(*keys) {
        launch(Dispatchers.Default) {
            state.value = callback()
        }
    }
    return state.value
}
